import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: "/",
    redirect: "/Index"
  }, {
    path: '/Index',
    name: 'Index',
    meta: {
      scrollToTop: true,
      title: '百乐便利'
    },
    component: () => import('../views/Index.vue')
  }, {
    path: '/home',
    name: 'Home',
    meta: {
      scrollToTop: true
    },
    component: () => import('../views/Home.vue')
  }, {
    path: '/article',
    name: 'Article',
    meta: {
      scrollToTop: true
    },
    component: () => import('../views/Article.vue')
  }, {
    path: '/errorPage',
    name: 'ErrorPage',
    meta: {
      scrollToTop: true,
      title: ''
    },
    component: () => import('../views/errorPage.vue')
  }, {
    path: '/feedback',
    name: 'Feedback',
    meta: {
      scrollToTop: true,
      title: '意见反馈'
    },
    component: () => import('../views/feedback.vue')
  }, {
    path: '/Trade',
    name: 'Trade',
    meta: {
      scrollToTop: true,
      title: '招商合作'
    },
    component: () => import('../views/Trade.vue')
  }, {
    path: '/Shops',
    name: 'Shops',
    meta: {
      scrollToTop: true,
      title: '联系我们'
    },
    component: () => import('../views/Shops.vue')
  }, {
    path: '/CateIndex',
    name: 'CateIndex',
    meta: {
      scrollToTop: true,
      title: '百乐课堂'
    },
    component: () => import('../views/CateIndex.vue')
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

// 防止路由重复点击报错
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default router
